<template>
	<ul>
		<li v-for="tag in Object.keys(getAllTags)" class="content-list" @click="listClick" :key="tag">
			<ProviderExpand :providerwise-patient-count="providerwisePatientCount[tag]"
				:total-count="providerwisePatientCount[tag]['total']"
                :toRoute="'/tag/' + tag"
                type="patients">
					<DeviceTagIcon :color="getTagColor(tag)"></DeviceTagIcon> {{ getAllTags[tag] }}
			</ProviderExpand>
		</li>
	</ul>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'
import ProviderExpand from './ProviderExpand'
import DeviceTagIcon from '@/module/component/DeviceTagIcon'


export default {
    name: 'sidebar-tag-list',
    extends: SidebarList,


    mounted() {
        if (this.getUserType === 'observer') {
            document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
			document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
        }
    },


    methods: {
        getTagColor(tag) {
            let tagObj = this.getTagToColorMapping.filter(obj => obj.id === tag)
            if (tagObj.length)  return tagObj[0].color
            else return '#000000'
        },
		listClick() {
			if (this.getUserType === 'observer') {
                document.querySelectorAll('.content-list a').forEach(element => element.style.backgroundColor = '#F8F8F8')
                document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
				document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
			}
		}
	},

    computed: {
        ...mapState('provider', [
            'providerPatients'
        ]),
        ...mapGetters('provider', [
            'getProviderPatientList',
            'getAllProviderPatientList',
            'getProviderList',
            'getTagToColorMapping'
        ]),
        ...mapGetters(['getUserType']),
        getAllTags() {
            let allTags = {}
            this.getAllProviderPatientListTags.forEach(patient => {
                patient.tag.forEach(tag => {
                    allTags[tag.id] = tag.desc || tag.description
                })
            })
            return allTags
        },
        getAllProviderPatientListTags() {
            return this.getAllProviderPatientList.filter(({ tag }) =>  tag)
        },
        providerwisePatientCount() {
            let masterObj = {}
            Object.keys(this.getAllTags).map(tagKey => {
                masterObj[tagKey] = {}
                const patientList = this.getAllProviderPatientListTags.filter(({ tag }) => {
                    return tag.filter(t => t.id === tagKey).length
                })
                let providerwiseObj = {
                    'total': patientList.length
                }
                if(this.getProviderList.length > 0)
                    masterObj[tagKey] = this.providerPatients.reduce((providerAcc, provider) => {
                        const patientCount = provider.patient.filter(({ tag }) => tag)
                        .filter(({ tag }) => {
                            return tag.filter(t => t.id === tagKey).length
                        }).length
                        providerAcc[provider.id] = patientCount
                        return providerAcc
                    }, providerwiseObj)
            })
            return masterObj
        }
    },

    components: {
        ProviderExpand,
        DeviceTagIcon
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
